import React from "react";

import ScheduleView from "./index";

export const ScheduleRoutes = () => <ScheduleView />;
